import http from './http'

/**
 * 查询教研室老师列表
 * 返回教研室所有老师的详细信息（姓名、工号等）
 */
export async function getDepartmentTeachers() {
    const res = await http.get('/user/info/department/teachers')
    return res.data
}

/**
 * 获取教研室老师ID列表
 * 返回教研室所有老师的ID数组
 */
export async function getDepartmentTeacherIds() {
    const res = await http.get('/user/info/department/teacher-ids')
    return res.data
}

/**
 * 查询教研室成果列表
 * 返回教研室所有成果的详细信息
 */
export async function getDepartmentAchievements(params) {
    const res = await http.get('/user/info/department/achievements', { params })
    return res.data
}
